import FinancialSituation from './FinancialSituation';

export default FinancialSituation;
